import { action } from 'typesafe-actions';
import { PedidoEntregaTypes, IRequest, IPedidoRes } from './types';

export const loadRequest = (request: IRequest) =>
  action(PedidoEntregaTypes.LOAD_REQUEST, { request });
export const loadSuccess = (data: IPedidoRes[]) =>
  action(PedidoEntregaTypes.LOAD_SUCCESS, { data });
export const loadFailure = () => action(PedidoEntregaTypes.LOAD_FAILURE, {});

export const cleanPedido = () => action(PedidoEntregaTypes.CLEAN_PEDIDO, {});
